import React, { useEffect, useState } from 'react';
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

const ContactSettings = () => {
  const [form, setForm] = useState({
    headerSmall: '',
    headerTitleLine1: '',
    headerTitleLine2: '',
    descriptionText: '',
    addressText: '',
    phonePrimary: '',
    phoneSecondary: '',
    emailAddress: '',
    servicesText: '',
  });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  useEffect(() => {
    const token = localStorage.getItem('adminToken');
    if (!token) {
      setLoading(false);
      return;
    }

    const fetchContent = async () => {
      try {
        const res = await axios.get(`${API_BASE_URL}/api/admin/contact-content`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const { contact } = res.data;
        if (contact) {
          setForm({
            headerSmall: contact.headerSmall || '',
            headerTitleLine1: contact.headerTitleLine1 || '',
            headerTitleLine2: contact.headerTitleLine2 || '',
            descriptionText: contact.descriptionText || '',
            addressText: contact.addressText || '',
            phonePrimary: contact.phonePrimary || '',
            phoneSecondary: contact.phoneSecondary || '',
            emailAddress: contact.emailAddress || '',
            servicesText: Array.isArray(contact.services)
              ? contact.services.map((s) => `${s.value}||${s.label}`).join('\n')
              : '',
          });
        }
      } catch {
        // ignore
      } finally {
        setLoading(false);
      }
    };

    fetchContent();
  }, []);

  const updateField = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const handleSave = async () => {
    setSaving(true);
    setError('');
    setSuccess('');

    const token = localStorage.getItem('adminToken');
    if (!token) {
      setError('انتهت صلاحية الجلسة، برجاء تسجيل الدخول مرة أخرى.');
      setSaving(false);
      return;
    }

    const services = form.servicesText
      ? form.servicesText
          .split('\n')
          .map((line) => line.trim())
          .filter(Boolean)
          .map((line) => {
            const [value, label] = line.split('||');
            return {
              value: (value || '').trim(),
              label: (label || '').trim(),
            };
          })
      : [];

    try {
      await axios.put(
        `${API_BASE_URL}/api/admin/contact-content`,
        {
          ...form,
          services,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setSuccess('تم حفظ إعدادات قسم الاتصال بنجاح.');
    } catch (err) {
      const message = err.response?.data?.message || 'حدث خطأ أثناء الحفظ.';
      setError(message);
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return <p>جاري تحميل إعدادات قسم الاتصال...</p>;
  }

  return (
    <div className="admin-section">
      <h2 className="admin-section-title">إعدادات قسم تواصل معنا</h2>
      <p className="admin-section-subtitle">
        يمكنك هنا تعديل نصوص ومعلومات الاتصال التي تظهر في قسم تواصل مع نبض كير، بالإضافة إلى
        خيارات نوع الخدمة في النموذج.
      </p>

      {error && <div className="admin-section-error">{error}</div>}
      {success && <div className="admin-section-success">{success}</div>}

      <div className="admin-grid-2">
        <div className="admin-field">
          <label>العنوان الصغير</label>
          <input
            type="text"
            value={form.headerSmall}
            onChange={(e) => updateField('headerSmall', e.target.value)}
            placeholder="تواصل مع نبض كير"
          />
        </div>
        <div className="admin-field">
          <label>العنوان الرئيسي - السطر الأول</label>
          <input
            type="text"
            value={form.headerTitleLine1}
            onChange={(e) => updateField('headerTitleLine1', e.target.value)}
            placeholder="نحن في نبض كير هنا لمساعدتك"
          />
        </div>
      </div>

      <div className="admin-grid-2">
        <div className="admin-field">
          <label>العنوان الرئيسي - السطر الثاني</label>
          <input
            type="text"
            value={form.headerTitleLine2}
            onChange={(e) => updateField('headerTitleLine2', e.target.value)}
            placeholder="في تنمية أعمالك"
          />
        </div>
        <div className="admin-field">
          <label>النص الوصفي</label>
          <input
            type="text"
            value={form.descriptionText}
            onChange={(e) => updateField('descriptionText', e.target.value)}
            placeholder="فريق نبض كير متاح للإجابة على جميع استفساراتك..."
          />
        </div>
      </div>

      <div className="admin-field">
        <label>نص العنوان (الموقع)</label>
        <textarea
          rows={3}
          value={form.addressText}
          onChange={(e) => updateField('addressText', e.target.value)}
          style={{ resize: 'vertical' }}
          placeholder={'الرياض، المملكة العربية السعودية\nطريق الملك فهد، برج العليا'}
        />
      </div>

      <div className="admin-grid-2">
        <div className="admin-field">
          <label>رقم الهاتف الأساسي</label>
          <input
            type="text"
            value={form.phonePrimary}
            onChange={(e) => updateField('phonePrimary', e.target.value)}
            placeholder="+966573394229"
          />
        </div>
        <div className="admin-field">
          <label>رقم هاتف إضافي (اختياري)</label>
          <input
            type="text"
            value={form.phoneSecondary}
            onChange={(e) => updateField('phoneSecondary', e.target.value)}
            placeholder="+966573394229"
          />
        </div>
      </div>

      <div className="admin-field">
        <label>البريد الإلكتروني</label>
        <input
          type="email"
          value={form.emailAddress}
          onChange={(e) => updateField('emailAddress', e.target.value)}
          placeholder="info@nabdh-ksa.com"
        />
      </div>

      <div className="admin-field">
        <label>خيارات نوع الخدمة (كل سطر: القيمة ثم || ثم النص المعروض)</label>
        <textarea
          rows={5}
          value={form.servicesText}
          onChange={(e) => updateField('servicesText', e.target.value)}
          style={{ resize: 'vertical' }}
          placeholder={
            'fda||هيئة الغذاء والدواء\nindustry||تراخيص صناعية\ncustoms||تخليص جمركي\nother||استشارة عامة'
          }
        />
        <small>مثال: fda||هيئة الغذاء والدواء</small>
      </div>

      <div className="admin-actions">
        <button
          type="button"
          className="admin-btn-primary"
          onClick={handleSave}
          disabled={saving}
        >
          {saving ? 'جاري الحفظ...' : 'حفظ الإعدادات'}
        </button>
      </div>
    </div>
  );
};

export default ContactSettings;

